// extracted by mini-css-extract-plugin
export default {"container":"accountData_container__z3bFO","row":"accountData_row__EMgpe","soloItem":"accountData_soloItem__+-JYb","item":"accountData_item__GYnXZ"};